import React, {useState, useEffect, useContext, Fragment, useRef} from 'react';
import {useParams} from 'react-router-dom'
import '@mantine/core/styles.css';
import {
    Button,
    Table,
    Flex,
    Text,
    Card,
    Group,
    Modal,
    Space,
    Center,
    Select,
    Alert,
    Drawer,
    LoadingOverlay
} from '@mantine/core';
import {LoginContext} from "./Login";
import {useDisclosure} from "@mantine/hooks";
import TopNavbar from "./components/TopNavbar";
import BreadcrumbsBar from "./components/BreadcrumbsBar";
import './css/Details.css'
import {IconAntennaBars3, IconAntennaBars5, IconChevronDown} from "@tabler/icons-react";
import classes from "./css/Results.module.css";
import {setLoading} from "./redux/actions";
import {useDispatch, useSelector} from "react-redux";
import ExportDrawer from "./components/ExportDrawer";
import MobileDetails from "./MobileDetails";
import {useTranslation} from "react-i18next";

export default function DetailsPage( {data} ) {
    const signalStrengthRenderer = (params) => {
        return (<span> {params==="N/A" || params == null ? "N/A": (params === "Good" ? <IconAntennaBars5 className={classes.tablerIconGreen}/> : <IconAntennaBars3 className={classes.tablerIconRed}/>)} </span>)
    }

    const id = useParams()
    const {logout, formatToBeaconDate, goBack} = useContext(LoginContext)
    const dispatch = useDispatch();

    const isLoading = useSelector(state => state.loading.isLoading);

    const [endpoint,setEndpoint] = useState()
    const [openedExportDrawer, { open: openDrawer, close: closeDrawer }] = useDisclosure(false);
    const customerObject = JSON.parse(localStorage.getItem("customers"))

    const [isMobile, setMobile] = useState(window.innerWidth < 768);

    const updateMedia = () => {
        setMobile(window.innerWidth < 768);
    };

    useEffect(() => {
        window.addEventListener("resize", updateMedia);
        return () => window.removeEventListener("resize", updateMedia);
    },[]);
    useEffect(()=>{
        dispatch(setLoading(true))
        fetch(`/api/v1/Activation/${id.endpointSN}`,{
            method:"GET",
            credentials: 'include',
        }).then(response=> response.json())
            .then(async result => {
                if (!result) {
                    openError()
                }
                setEndpoint(result)
                dispatch(setLoading(false))

            }).catch((error)=>{
            console.log(error)
            logout() //logout if error, likely due to expired cookie
            dispatch(setLoading(false))
            //alert("Network Error, please try again!")
        })
    },[]);

    const [openedError, { open: openError, close: closeError }] = useDisclosure(false);
    const { t } = useTranslation();
    return (
        <div>
            <TopNavbar logout={logout} isMobile={isMobile} refreshPage={goBack} openExportDrawer={openDrawer}/>
            <ExportDrawer isOpen={openedExportDrawer} closeDrawer={closeDrawer} isMobile={isMobile}/>
            <Modal
                opened={openedError}
                onClose={goBack}
                overlayProps={{blur: 5}}
                title={t("Activation Not Found")}
            >
                {t("sn-not-found",{n: id.endpointSN})}
            </Modal>
            {isMobile ? (<MobileDetails
                            endpoint={endpoint}
                            signalStrengthRenderer={signalStrengthRenderer}
                            logout={logout}
                            formatToBeaconDate={formatToBeaconDate}
                            goBack={goBack}
                            isLoading={isLoading}
                            customerObject={customerObject}
                        />) : (<div>
                <Card w="100%" bg="#FAFAFB" withBorder>
                <BreadcrumbsBar goBack={goBack} id={id}/>
                </Card>
                {
                    endpoint ? (
                        <Card shadow="xl" mt="xl" withBorder className="card"
                               style={{
                                   width: '100%', // Full width on small screens
                                   maxWidth: '1000px', // Limit width on larger screens
                                   margin: '0 auto', // Center horizontally
                               }}
                               p="xl"
                            >
                            <Text size="xl" fw={700}>{t("Endpoint SN")}: {endpoint.SerialNumber}</Text>
                            <Space h="sm"/>
                            <Table>
                                <Table.Thead>
                                <Table.Tr>
                                    <Table.Th>{t("Encoder SN")}</Table.Th>
                                    <Table.Th>{t("Customer Name")}</Table.Th>
                                    <Table.Th>{t("Activation Time")}</Table.Th>
                                    <Table.Th>{t("Signal Strength")}</Table.Th>
                                    <Table.Th>{t("Endpoint Status")}</Table.Th>
                                    <Table.Th>{t("Meter Status")}</Table.Th>
                                    <Table.Th>{t("Last Communication Time")}</Table.Th>
                                    <Table.Th>{t("last-read")}</Table.Th>
                                    </Table.Tr>
                                </Table.Thead>
                                <Table.Tbody>
                                    <Table.Tr>
                                        <Table.Td>{endpoint.EncoderSerialNumber}</Table.Td>
                                        <Table.Td>{Object.keys(customerObject).find(e => customerObject[e] === endpoint.CustomerUuid)}</Table.Td>
                                        <Table.Td>{formatToBeaconDate(endpoint.ActivationTime)}</Table.Td>
                                        <Table.Td>{signalStrengthRenderer(endpoint.NetworkStatus)}</Table.Td>
                                        <Table.Td>{t(endpoint.EndpointStatus)}</Table.Td>
                                        <Table.Td>{t(endpoint.MeterStatus)}</Table.Td>
                                        <Table.Td>{formatToBeaconDate(endpoint.LastCommunicationTime)}</Table.Td>
                                        <Table.Td>{endpoint.LastRead}</Table.Td>
                                    </Table.Tr>

                                </Table.Tbody>
                            </Table>
                        </Card>) : (<div><Card shadow="xl" mt="xl" withBorder className="card"
                                                              style={{
                                                                  width: '100%', // Full width on small screens
                                                                  maxWidth: '1000px', // Limit width on larger screens
                                                                  margin: '0 auto', // Center horizontally
                                                              }}
                                                              p="xl"
                    ><LoadingOverlay visible={isLoading} zIndex={10} overlayProps={{ radius: "sm", blur: 10000 }}/><Text size="xl" fw={700}>{t("Endpoint SN")}: </Text>
                        <Space h="sm"/>
                        <Table>
                            <Table.Thead>
                                <Table.Tr>
                                    <Table.Th>{t("Encoder SN")}</Table.Th>
                                    <Table.Th>{t("Customer Name")}</Table.Th>
                                    <Table.Th>{t("Activation Time")}</Table.Th>
                                    <Table.Th>{t("Signal Strength")}</Table.Th>
                                    <Table.Th>{t("Endpoint Status")}</Table.Th>
                                    <Table.Th>{t("Meter Status")}</Table.Th>
                                    <Table.Th>{t("Last Communication Time")}</Table.Th>
                                    <Table.Th>{t("last-read")}</Table.Th>
                                </Table.Tr>
                            </Table.Thead>
                            <Table.Tbody>
                                <Table.Tr>
                                    <Table.Td>-</Table.Td>
                                    <Table.Td>-</Table.Td>
                                    <Table.Td>0/0/0000 00:00 </Table.Td>
                                    <Table.Td>-</Table.Td>
                                    <Table.Td>-</Table.Td>
                                    <Table.Td>-</Table.Td>
                                    <Table.Td>-</Table.Td>
                                    <Table.Td>-</Table.Td>
                                </Table.Tr>

                            </Table.Tbody>
                        </Table></Card></div>)
                }
            </div>)}</div>);

};